<body>

	<div id="notfound">
		<div class="notfound-bg"></div>
		<div class="notfound">
            <div>
                <img src="../../assets/images/logo_white.png" style="width: 10rem;" alt="">
            </div>
			<div class="notfound-404">
				<h1>404</h1>
			</div>
			<h2>we are sorry, but the page you requested was not found</h2>
			<a href="home" class="home-btn">Go Home</a>
			<a href="http://ganizaniconsultingservices.co.za/contact/" target="_blank" class="contact-btn">Contact us</a>
			<div class="notfound-social">
				<a href="mailTo: info@ganizaniconsultingservices.co.za"><i class="fa fa-envelope"></i></a> info@ganizaniconsultingservices.co.za
			</div>
		</div>
	</div>

</body>